var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-back',{on:{"click":_vm.click}},[_c('span',[_vm._v(_vm._s(_vm.year))])])}
var staticRenderFns = []

export { render, staticRenderFns }